import React, { FC } from 'react';
import type { IconifyIconProps as IconifyProps } from '@iconify-icon/react';
import { Icon } from '@iconify-icon/react';

export type IconifyIconProps =Omit<IconifyProps, 'ref'>;

export const IconifyIcon: FC<IconifyIconProps> = ({ icon  , ...props }) => (
  <Icon icon={icon} {...props} />
);
